/**
* @license Apache-2.0
*
* Copyright (c) 2021 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Add two single-precision complex floating-point numbers.
*
* @module @stdlib/math-base-ops-caddf
*
* @example
* var Complex64 = require( '@stdlib/complex-float32' );
* var realf = require( '@stdlib/complex-realf' );
* var imagf = require( '@stdlib/complex-imagf' );
* var caddf = require( '@stdlib/math-base-ops-caddf' );
*
* var z = new Complex64( 5.0, 3.0 );
* // returns <Complex64>
*
* var out = caddf( z, z );
* // returns <Complex64>
*
* var re = realf( out );
* // returns 10.0
*
* var im = imagf( out );
* // returns 6.0
*/

// MODULES //

var main = require( './main.js' );


// EXPORTS //

module.exports = main;
